// Helper functions to generate schema from existing data

export const generateProductSchema = (product: {
  name: string;
  price: string;
  description: string;
  features?: string[];
}) => {
  // Extract numeric price from strings like "$49/month" or "Starting at $99"
  const priceMatch = product.price.match(/\$?([\d,]+)/);
  const price = priceMatch ? priceMatch[1].replace(',', '') : '0';
  
  return {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": product.name,
    "description": product.description,
    "offers": {
      "@type": "Offer",
      "price": price,
      "priceCurrency": "USD",
      "availability": "https://schema.org/InStock",
      "priceValidUntil": new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0]
    },
    ...(product.features && {
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "127"
      }
    })
  };
};

export const generateFAQSchema = (faqs: Array<{ question: string; answer: string }>) => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };
};

export const generateBreadcrumbSchema = (items: Array<{ name: string; url: string }>) => {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": `https://simnetwireless.com${item.url}`
    }))
  };
};

export const generateOrganizationSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "SimNet Wireless",
    "url": "https://simnetwireless.com",
    "logo": "https://simnetwireless.com/logo.png",
    "description": "Enterprise-grade connectivity solutions including business internet, failover protection, IoT connectivity, and asset tracking services.",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+1-512-859-5047",
      "contactType": "customer service",
      "areaServed": "US",
      "availableLanguage": "English"
    },
    "sameAs": [
      "https://www.facebook.com/simnetwireless",
      "https://www.linkedin.com/company/simnet-wireless",
      "https://twitter.com/simnetwireless"
    ]
  };
};

export const generateLocalBusinessSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "SimNet Wireless",
    "image": "https://simnetwireless.com/logo.png",
    "description": "Enterprise connectivity provider specializing in business internet, failover solutions, and IoT connectivity.",
    "@id": "https://simnetwireless.com",
    "url": "https://simnetwireless.com",
    "telephone": "+1-512-859-5047",
    "email": "sales@simnetwireless.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Central Texas",
      "addressRegion": "TX",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 30.2672,
      "longitude": -97.7431
    },
    "priceRange": "$$",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "08:00",
        "closes": "18:00"
      }
    ],
    "areaServed": {
      "@type": "Country",
      "name": "United States"
    }
  };
};

export const generateServiceSchema = (service: {
  name: string;
  description: string;
}) => {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": service.name,
    "description": service.description,
    "provider": {
      "@type": "Organization",
      "name": "SimNet Wireless"
    },
    "areaServed": {
      "@type": "Country",
      "name": "United States"
    }
  };
};
